function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateSku();
    }
  }

  updateSku() {
    getSku(this.currentVariant.id);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {

    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = document.querySelector(
      `[data-media-id-variant="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    const switshMedia = document.querySelector(
      `[data-media-id-variant-outer="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    const newSwithMedia = switshMedia.innerHTML
    var theNewImage = document.getElementById('productMediaBig')
    theNewImage.innerHTML = newSwithMedia;
    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      //parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    console.log(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        //console.log(source.innerHTML+" "+destination.innerHTML)

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);


$( document ).ready(function() {
  if (document.getElementsByClassName('banner-slider').length > 0) {
    loadImageSlider()
  }
  if (document.getElementsByClassName('main-carousel').length > 0) {
    loadUtilitySlider()
  }
  if (document.getElementsByClassName('recently-viewed-products').length > 0) {
    let elem = document.getElementsByClassName('recently-viewed-products')[0]
    renderProducts(elem)
  }
  if (document.getElementsByClassName('modal-outer-quickshop').length > 0) {
    quickshopTrigger('list')
  }
  if (document.getElementById('RegisterForm-yTunnus')) {
    initFormValidation()
  }
  mainMenuTrigger()
  if (window.location.href.indexOf('/products/') !== -1) {
    let productHandle = window.location.href.split('/products/')[1]
    saveRecentView(productHandle)
  }
});

function initFormValidation(){
  $('#register_btn').click(
      function(event) {
         event.preventDefault();
         registerFormValidation()
      }
   );
}

function registerFormValidation(){
  var errorCount = 0
  var firstName = $('#RegisterForm-FirstName').val()
  var lastName = $('#RegisterForm-LastName').val()
  var email = $('#RegisterForm-email').val()
  var yritys = $('#RegisterForm-yritys').val()
  var ytunnus = $('#RegisterForm-yTunnus').val()
  var password = $('#RegisterForm-password').val()
  if (firstName.length < 2){
    errorCount++
    $("#RegisterForm-firstname-error").css('display','flex')
  } else {
    $("#RegisterForm-firstname-error").css('display','none')
  }
  if (lastName.length < 2){
    errorCount++
    $("#RegisterForm-lastname-error").css('display','flex')
  } else {
    $("#RegisterForm-lastname-error").css('display','none')
  }
  if (validateEmail(email) == false){
    errorCount++
    $("#RegisterForm-email-error").css('display','flex')
  } else {
    $("#RegisterForm-email-error").css('display','none')
  }
  if (yritys.length < 4){
    errorCount++
    $("#RegisterForm-yritys-error").css('display','flex')
  } else {
    $("#RegisterForm-yritys-error").css('display','none')
  }
  if (validateYtunnus(ytunnus) == false){
    errorCount++
    $("#RegisterForm-ytunnus-error").css('display','flex')
  } else {
    $("#RegisterForm-ytunnus-error").css('display','none')
  }
  if (password.length < 5){
    errorCount++
    $("#RegisterForm-password-error").css('display','flex')
  } else {
    $("#RegisterForm-password-error").css('display','none')
  }

  if (errorCount == 0){
    $( "#create_customer" ).submit();
  }

}

function validateEmail(email){
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}
function validateYtunnus(ytunnus){
    if (ytunnus.indexOf('-') === -1 || ytunnus.length != 9){
      return false
    } else {
      return true
    }
}


function renderProducts(elem){
  let recentViewArr = JSON.parse(localStorage.getItem('recentView'));
  if (!recentViewArr){
    return
  }
  let element1 = document.createElement('li');
  element1.style.order = 4
  element1.setAttribute('class','grid__item')
  let element2 = document.createElement('li');
  element2.style.order = 3
  element2.setAttribute('class','grid__item')
  let element3 = document.createElement('li');
  element3.style.order = 2
  element3.setAttribute('class','grid__item')
  let element4 = document.createElement('li');
  element4.style.order = 1
  element4.setAttribute('class','grid__item')


  let euroEU = Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });

  for (i=0;recentViewArr.length>i;i++){
    let handle = recentViewArr[i].handle;
    let order = recentViewArr[i].id;
    $.getJSON('/products/'+handle+'.js', function(product) {

	  let product_images_class = ''
	  let product_images_title_class = ''
	  let product_tags = product.tags
	  let product_tags_class = ''
      let compare_at_price_class = ''
      let regular_price_class = ''
      let compare_at_price = 0
      let price = (Number(product.price)/100).toFixed(2)
      /*price = price.toLocaleString('de-DE', {
        maximumSignificantDigits: 2,style: 'currency', currency: 'EUR'
      });
       */
      if (product.compare_at_price === null){
        compare_at_price_class = ' hidden';
      } else {
        compare_at_price = (Number(product.compare_at_price)/100).toFixed(2)
      }
      if (product_tags.includes('uutuus')) {
      	product_tags_class = '';
      } else {
        product_tags_class = ' hidden';
      }
      if (product_tags.includes('tarjouspyynto')) {
      	product_offer_class = ' hidden';
      } else {
        product_offer_class = '';
      }
      if (product.images != '') {
       	product_images_class = '';
       	product_images_title_class = 'hidden';
      } else {
        product_images_class = ' hidden';
        product_images_title_class = '';
      }

      let html =
        '<div class="card-wrapper">'+
          '<div class="buttons-product-buy">'+
            '<div class="buttons-product-buy-inner"></div>'+
            '<div class="buttons-btn-wrapper">'+
              '<div class="preview-btn product-list-btn">'+
                '<span class="hidden" id="desc_'+handle+'">'+
                  product.description+
                '</span>'+
                '<span class="hidden" id="price_'+product.handle+'">'+euroEU.format(price)+'</span>'+
                '<span class="hidden" id="add_'+product.handle+'">'+
                 '<label class="form__label">'+
                 window.variantStrings.quantityLabel+
                  '</label>'+
                  '<quantity-input class="quantity">'+
                      '<button class="quantity__button no-js-hidden" name="minus" type="button">'+
                        '<span class="visually-hidden">'+window.variantStrings.decrease+'</span>'+
                        '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">\n' +
          '  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">\n' +
          '</path></svg>'+
                      '</button>'+
                      '<input class="quantity__input"'+
                             ' type="number"'+
                             ' name="quantity"'+
                             ' data-id="Quantity-'+product.id+'"'+
                             ' min="1"'+
                             ' value="1"'+
                      '>'+
                      '<button class="quantity__button no-js-hidden" name="plus" type="button">'+
                        '<span class="visually-hidden">'+window.variantStrings.increase+'</span>'+
                        '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">\n' +
          '  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">\n' +
          '</path></svg>'+
                      '</button>'+
                  '</quantity-input>'+
                  '<button onClick="addItemToCart('+product.variants[0].id+', \'Quantity-'+product.id+'\', 1, \'Months\')">'+window.variantStrings.add_to_cart+'</button>'+
                '</span>'+
                '<a'+
                    ' data-product-handle="'+product.handle+'"'+
                    ' data-product-name="'+product.title+'"'+
                    ' data-product-vendor="'+product.vendor+'"'+
                    ' data-product-link="'+product.url+'"'+
                    ' data-product-sku="'+product.variants[0].sku+'"'+
                    ' class="button quickshop-trigger'+order+' button--primary button--primary color-color_scheme_1">'+window.variantStrings.preview+'</a>'+
              '</div>'+
              '<div class="buy-btn product-list-btn">'+
                '<a href="'+window.variantStrings.locale+product.url+'"'+
                   ' class="button button--primary color-color_scheme_2"><span'+
                   ' class="desctop">'+window.variantStrings.open_product_page+'</span><span class="mobile">'+window.variantStrings.open_product_page_short+'</span></a>'+
              '</div>'+
            '</div>'+
          '</div>'+
          '<div class="card-information" >'+
              '<div class="card-information__wrapper" >'+
                '<div class="caption-with-letter-spacing light">'+product.vendor+'</div>'+
                '<div class="caption-with-letter-spacing caption-with-letter-spacing_nomargin light">'+product.variants[0].sku+'</div>'+
                '<h3 class="card-information__text h5" >'+
                  '<a href="/products/dogleggs-thevest-small" class="full-unstyled-link" >'+
                    product.title+
                  '</a>'+
                '</h3>'+
                '<span class="caption-large light"></span>'+
                '<div class="price price--on-sale '+product_offer_class+'">'+
                '<div>'+
                 /* '<div class="price__regular">'+
                    '<span class="visually-hidden visually-hidden--inline">'+product.price/100+'</span>'+
                    '<span class="price-item price-item--regular">'+
                      +product.price/100+' €'+
                    '</span>'+
                  '</div>'+ */
                  '<div class="price__sale">'+
                    '<span class="visually-hidden visually-hidden--inline">'+window.variantStrings.regular_price+'</span>'+
                    '<span>'+
                      '<s class="price-item price-item--regular '+compare_at_price_class+'">'+
                        euroEU.format(price)+
                      '</s>'+
                    '</span>'+
                    '<span class="visually-hidden visually-hidden--inline">'+window.variantStrings.sale_price+'</span>'+
                    '<span class="price-item price-item--sale price-item--last">'+
                      euroEU.format(price)+
                    '</span>'+
                  '</div>'+
                '</div>'+
              '</div>'+
            '</div>'+
          '</div>'+

          '<div class="card card--product card--outline '+product_images_class+'" tabIndex="-1">'+
            '<div class="card__inner">'+
              '<div class="card__media-full-spacer">'+
                '<div class="media media--transparent media--square media--hover-effect" id="img_'+handle+'">'+
                  '<img class="'+product_images_class+'"'+
                      ' srcSet="'+product.images+'"'+
                      ' src="'+product.images+'"'+
                      ' sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"'+
                      ' alt="" loading="lazy" class="motion-reduce" width="580" height="599">'+
                '</div>'+
              '</div>'+
              '<div class="card__badge">'+
                '<span class="badge badge--bottom-left color-accent-1 '+compare_at_price_class+'">'+
                  window.variantStrings.on_sale+
                '</span>'+
              '</div>'+
              '<div class="product__tag-new color-background-2 '+product_tags_class+'">'+window.variantStrings.new+'</div>'+
            '</div>'+
          '</div>'+
          '<div class="card card--product card--text-only card--soft '+product_images_title_class+'" tabIndex="-1">'+
            '<div class="card__inner">'+
              '<div class="card__content">'+
          		'<h2 class="card__text h3">'+
          		  '<a href="" class="full-unstyled-link">'+
          		    product.title+
          		  '</a>'+
          		'</h2>'+
          	  '</div>'+
              '<div class="card__badge">'+
                '<span class="badge badge--bottom-left color-accent-1 '+compare_at_price_class+'">'+
                  window.variantStrings.on_sale+
                '</span>'+
              '</div>'+
              '<div class="product__tag-new color-background-2 '+product_tags_class+'">'+window.variantStrings.new+'</div>'+
            '</div>'+
          '</div>'+
        '</div>'
      if (order == 1){
        element1.innerHTML = html
        elem.append(element1)
        quickshopTrigger('recent1')
      } else if (order == 2){
        element2.innerHTML = html
        elem.append(element2)
        quickshopTrigger('recent2')
      } else if (order == 3){
        element3.innerHTML = html
        elem.append(element3)
        quickshopTrigger('recent3')
      } else if (order == 4){
        element4.innerHTML = html
        elem.append(element4)
        quickshopTrigger('recent4')
      }
    })
  }

}

function saveRecentView(productHandle){
  if ( productHandle.indexOf('?') !== -1 ) {
      productHandle = productHandle.split('?')[0]
    }
    let recentViewArr = JSON.parse(localStorage.getItem('recentView'));

    let stop = 0;
    if (recentViewArr){
      for (y=0;recentViewArr.length>y;y++){
        if (recentViewArr[y].handle == productHandle){
          stop = 1
        }
      }
    }
    if (recentViewArr && recentViewArr.length > 0 && stop==0 ){
      for (i=0;recentViewArr.length>i;i++){
        recentViewArr[i].id = recentViewArr[i].id-1
      }
      recentViewArr.push( {id:4,handle: productHandle} )
    } else if (!recentViewArr){
      recentViewArr = [{id:4,handle: productHandle}];
    }
    if (recentViewArr.length > 4){
      recentViewArr.shift()
    }
    localStorage.setItem('recentView', JSON.stringify(recentViewArr));
}

function quickshopTrigger(recent){
  let thisElem = document.getElementsByClassName('modal-outer-quickshop')[0];
  thisElem.getElementsByClassName('close-quickshop')[0].addEventListener('click', function (event) {
    thisElem.style.display = 'none'
    document.body.style.overflow = 'auto'
  })
  let quickshopButtons
  if (recent && recent == 'recent1'){
    quickshopButtons = document.getElementsByClassName('quickshop-trigger1')
    quickshopButtonsFunction(quickshopButtons,thisElem)
  }
  else if (recent && recent == 'recent2'){
    quickshopButtons = document.getElementsByClassName('quickshop-trigger2')
    quickshopButtonsFunction(quickshopButtons,thisElem)
  }
  else if (recent && recent == 'recent3'){
    quickshopButtons = document.getElementsByClassName('quickshop-trigger3')
    quickshopButtonsFunction(quickshopButtons,thisElem)
  }
  else if (recent && recent == 'recent4'){
    quickshopButtons = document.getElementsByClassName('quickshop-trigger4')
    quickshopButtonsFunction(quickshopButtons,thisElem)
  }
  else if (recent && recent == 'list'){
    quickshopButtons = document.getElementsByClassName('quickshop-trigger')
    quickshopButtonsFunction(quickshopButtons,thisElem)
  }
  else if (recent && recent == 'recommendations'){
    var elemRecommendations = document.getElementsByClassName('product-recommendations')[0]
    quickshopButtons = elemRecommendations.getElementsByClassName('quickshop-trigger')
    quickshopButtonsFunction(quickshopButtons,thisElem)
  }
}

function prodRecommendationQuickshop(){
  var recElem = document.getElementsByClassName('product-recommendations')[0]
  if (recElem){
    quickshopTrigger('recommendations')
  }
}

function quickshopButtonsFunction(quickshopButtons,thisElem){

  if (quickshopButtons.length > 0) {
    runQuickshopButtons(quickshopButtons, thisElem)
  }

  function runQuickshopButtons(quickshopButtons,thisElem) {
    for (x = 0; quickshopButtons.length > x; x++) {
      let thisBtn = quickshopButtons[x]
      thisBtn.addEventListener('click', function (event) {
        event.preventDefault()
        document.body.style.overflow = 'hidden'
        let handle = thisBtn.getAttribute('data-product-handle')
        saveRecentView(handle)
        const accessory_type = thisBtn.getAttribute('data-product-accessory')
        console.log('accessory_type: '+accessory_type)
        document.getElementById('p-name').innerHTML = thisBtn.getAttribute('data-product-name')
        document.getElementById('p-vendor').innerHTML = thisBtn.getAttribute('data-product-vendor')
        document.getElementById('p-sku').innerHTML = '<span class="sku-title">'+window.variantStrings.sku+': </span>' + thisBtn.getAttribute('data-product-sku')
        document.getElementById('p-link-tag').setAttribute('href', window.variantStrings.locale+thisBtn.getAttribute('data-product-link'))
        if (document.getElementById('p-desc') && document.getElementById('desc_' + handle)){
          document.getElementById('p-desc').innerHTML = document.getElementById('desc_' + handle).innerHTML
        } else {
          document.getElementById('p-desc').innerHTML = ''
        }
        if (document.getElementById('p-price') && document.getElementById('price_' + handle)){
          document.getElementById('p-price').innerHTML = document.getElementById('price_' + handle).innerHTML
        } else {
          document.getElementById('p-price').innerHTML = ''
        }
        if (document.getElementById('p-add') && document.getElementById('add_' + handle) && !accessory_type){
          document.getElementById('p-add').innerHTML = document.getElementById('add_' + handle).innerHTML
        } else {
          document.getElementById('p-add').innerHTML = ''
        }
        let productInfo = document.getElementById('add_' + handle)
        let qId
        if (productInfo){
          qId = productInfo.getElementsByClassName("quantity__input")[0].getAttribute("data-id")
        }
        let modalInfo = document.getElementById('p-add')
        if (modalInfo && modalInfo.getElementsByClassName("quantity__input")[0]){
          modalInfo.getElementsByClassName("quantity__input")[0].setAttribute("id", qId)
        }
        if (document.getElementById('p-img') && document.getElementById('img_' + handle)){
          document.getElementById('p-img').innerHTML = document.getElementById('img_' + handle).innerHTML
        }
        thisElem.style.display = 'flex'
      })
    }
  }

}

function addItemToCart(variant_id, qty_selector, frequency, unit_type) {
 let qty = document.getElementById(qty_selector).value
 let formData = {
   'items': [{
    'id': variant_id,
    'quantity': qty
    }]
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    var toAddAmount = 0
    var cartBuble = document.getElementById('cart-count-bubble')
    if (cartBuble){
      toAddAmount = Number(cartBuble.innerHTML)
    } else {
      var addBubble = document.createElement('div')
      var addBubbleInner = document.createElement('span')
      addBubble.setAttribute('class','cart-count-bubble')
      addBubbleInner.setAttribute('id','cart-count-bubble')
      addBubbleInner.innerHTML = 0;
      addBubble.appendChild(addBubbleInner)
      document.getElementById('cart-icon-bubble').appendChild(addBubble)
    }
    document.getElementById('cart-count-bubble').innerHTML = Number(qty)+toAddAmount
    document.getElementsByClassName('close-quickshop')[0].click()
    document.body.style.overflow = 'auto'
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
